module.exports = {"id":"14907","name":"Albano Bizzarri","rating":"75","photo":"./data/images/photos/1/14907.png","club":{"name":"Udinese","logo":"./data/images/clubs/Udinese.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlbanoBizzarri0.json
// module id = 156
// module chunks = 0